"use client"

import { useInView } from "react-intersection-observer"
import "../assets/css/potting-mix.css"
import pottingMixImage from "../assets/images/products/potting-mix2.webp"

export default function PottingMix() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  return (
    <section ref={ref} className="potting-mix-section">
      <div className="container">
        <div className="potting-mix-grid">
          <div className={`potting-mix-content ${inView ? "visible" : ""}`}>
            <h2 className="potting-mix-title">Premium Potting Mix</h2>
            <h3 className="potting-mix-subtitle">Your All-in-One Organic Growing Solution</h3>
            <p className="potting-mix-description">
              Finding the right soil and fertilizer for healthy plant growth can be a challenge for households and businesses. Our Premium Potting Mix is the perfect solution—an international standard blend designed for convenience and superior results. This mix does not include ground soil, ensuring a clean, organic medium that is ready to use. Made from natural components like coconut husks, peat, and rice husks extracted from Sri Lanka, it is germinated to prevent harmful bacteria and diseases. Engineered to retain moisture, protect against temperature extremes, and provide balanced nutrients, this mix is ideal for germinating seeds and growing vegetables, flowers, and herbs—indoors or outdoors. A hassle-free way to achieve vibrant, healthy plants without soil searches or separate fertilizers.
            </p>

            <div className="potting-mix-features">
              <div className="potting-mix-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">100% Organic from Sri Lanka</p>
              </div>
              <div className="potting-mix-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">Disease-free germinated blend</p>
              </div>
              <div className="potting-mix-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">Protects against temperature extremes and moisture loss</p>
              </div>
              <div className="potting-mix-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">No added fertilizer required—feeds plants up to 6 months</p>
              </div>
              <div className="potting-mix-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">Perfect for seeds, vegetables, flowers, and herbs</p>
              </div>
            </div>
            <a
              className="learn-more-btn"
              href="/learn-more-potting-mix"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More...
            </a>
          </div>

          <div className={`potting-mix-image-container ${inView ? "visible" : ""}`}>
            <div className="potting-mix-image">
              <img
                src={pottingMixImage}
                alt="Premium Potting Mix"
                width={600}
                height={800}
                className="image"
                style={{ objectFit: "cover", width: "100%", height: "auto" }}
              />
              <div className="potting-mix-badge">Organic</div>
            </div>
          </div>
        </div>
      </div>

      {/* Animated background elements */}
      <div className="animated-bg animated-bg-1"></div>
      <div className="animated-bg animated-bg-2"></div>
    </section>
  )
}
